// extracted by mini-css-extract-plugin
export default {"SplitPageLayout":"Search-module__SplitPageLayout--vH5Ht","SplitPageLayout_Content":"Search-module__SplitPageLayout_Content--mt9an"};